const API_BASE_URL = process.env.REACT_APP_PHP_API_BASE_URL;

export async function getChats(pageData) {
	const response = await fetch(`${API_BASE_URL}/chat-logs/getChats/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
		// headers: {
		// 	'Content-Type': 'application/json'
		// },
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the chat logs.');
	}

	const data = await response.json();

	// if (!data['success']) { // Manually created and returned attributes
	// 	throw new Error(data['status_code'] + ': ' + data['status']);
	// }
	// console.log('DATA');
	// console.log(data);
	return data;
}

export async function getChat(pageData) {
	const response = await fetch(`${API_BASE_URL}/chat-logs/getChat/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the competiscan report.');
	}

	const data = await response.json();

	return data;
}
